var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 text-xl w-full text-center bg-white"},[_c('header',{staticClass:"flex justify-between"},[_c('img',{attrs:{"src":"https://app.digitaltolk.se/assets/images/brand-logo.svg","alt":"DigitalTolk"}}),_c('LocaleDropDown')],1),_c('div',[_c('GuestForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }